import request from '@/utils/request'

// 列表
export function apiGetStandardProcessList (params) {
  return request({
    url: '/bom/bomRoutingHeaderCc/list',
    method: 'get',
    params: params
  })
}

// 新增
export function apiAddStandardProcess (data) {
  return request({
    url: '/bom/bomRoutingHeaderCc',
    method: 'post',
    data: data
  })
}

// 修改
export function apiUpdateStandardProcess (data) {
  return request({
    url: '/bom/bomRoutingHeaderCc',
    method: 'PUT',
    data: data
  })
}

// 删除
export function apiDeleteStandardProcess (ids) {
  return request({
    url: `/bom/bomRoutingHeaderCc/${ids}`,
    method: 'delete'
  })
}

// 工艺路线
export function apiBomRoutingHeaderFindList (query) {
  return request({
    url: `/bom/bomRoutingHeader/findList`,
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiExportStandardProcess (data) {
  return request({
    url: '/bom/bomRoutingHeaderCc/export',
    method: 'post',
    data: data
  })
}

// 工序编码
export function apiBomOperationFindList (query) {
  return request({
    url: '/bom/bomOperation/findList',
    method: 'get',
    params: query
  })
}

// 修改
export function apiBomRoutingHeaderUpdate (data) {
  return request({
    url: '/bom/bomRoutingHeader',
    method: 'put',
    data: data
  })
}

// 详情 - 关联工序 - 列表
export function apiGetBomRoutingLineCc (params) {
  return request({
    url: `/bom/bomRoutingLineCc/list`,
    method: 'get',
    params
  })
}

// 详情 - 关联工序 - 新增
export function apiAddBomRoutingLineCc (params) {
  return request({
    url: `/bom/bomRoutingLineCc`,
    method: 'post',
    data: params
  })
}

// 详情 - 关联工序 - 修改
export function apiUpdateBomRoutingLineCc (params) {
  return request({
    url: `/bom/bomRoutingLineCc`,
    method: 'PUT',
    data: params
  })
}

// 详情 - 关联工序 - 删除
export function apiDeleteBomRoutingLineCc (id) {
  return request({
    url: `/bom/bomRoutingLineCc/${id}`,
    method: 'delete'
  })
}

// 详情 - 关联物料 - 列表
export function apiGetRoutingLineCcItem (params) {
  return request({
    url: `/bom//bomRoutingLineCcItem/list`,
    method: 'get',
    params
  })
}

// 详情 - 关联物料 - 新增
export function apiRoutingLineCcItem (params) {
  return request({
    url: `/bom/bomRoutingLineCcItem`,
    method: 'post',
    data: params
  })
}

// 详情 - 关联物料 - 修改
export function apiUpdateRoutingLineCcItem (params) {
  return request({
    url: `/bom/bomRoutingLineCcItem`,
    method: 'PUT',
    data: params
  })
}

// 详情 - 关联物料 - 删除
export function apiDeleteRoutingLineCcItem (id) {
  return request({
    url: `/bom/bomRoutingLineCcItem/${id}`,
    method: 'delete'
  })
}

// 详情 - 工作中心 - 列表
export function apiGetRoutingLineCcWorkCenter (params) {
  return request({
    url: `/bom/bomRoutingLineCcWorkCenter/list`,
    method: 'get',
    params
  })
}

// 详情 - 工作中心 - 新增
export function apiRoutingLineCcWorkCenter (params) {
  return request({
    url: `/bom/bomRoutingLineCcWorkCenter`,
    method: 'post',
    data: params
  })
}

// 详情 - 工作中心 - 修改
export function apiUpdateRoutingLineCcWorkCenter (params) {
  return request({
    url: `/bom/bomRoutingLineCcWorkCenter`,
    method: 'PUT',
    data: params
  })
}

// 详情 - 工作中心 - 删除
export function apiDeleteRoutingLineCcWorkCenter (id) {
  return request({
    url: `/bom/bomRoutingLineCcWorkCenter/${id}`,
    method: 'delete'
  })
}
